import React, { useState, useContext, ReactElement } from 'react'
import {
  HideIcon,
  CrowdfundIcon,
  GoalsIcon,
  ShareMessengerIcon,
  CopyToClipboardIcon,
  HorizontalScroll,
} from '@paypalcorp/pp-react'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import * as styles from './intro.css'
import useWindowSize from '../../utils/useWindowSize'
import serverData from '../../utils/server-data'
import { getCurrencyElements } from './IntroHelpers'
import { ImageConfiguration } from '../../../../typings'
import { tracking } from '../../lib/analytics/fpti'
import Events from '../../lib/analytics/eventTags.js'
import { ContainerGeneration } from './ContainerGeneration'

import { isAnonymousAmountEnabled } from '../../utils/features'

type IntroPage = {
  id: string
  images: ImageConfiguration
  title: string
  firstIcon: ReactElement
  firstSubtitle: string
  secondIcon: ReactElement
  secondSubtitle: string
  showPrivacyLink?: boolean
}

export const IntroContent = ({
  goToPrivacyScreen,
  pageVariant,
}: {
  goToPrivacyScreen: () => void
  pageVariant: string
}) => {
  const { isSmallScreen, isSmallerScreen } = useWindowSize()
  const currentUserCountryCode = useContext(WorldReadyContext).region
  const [currentPage, setCurrentPage] = useState(1)

  const handlePageChange = (index: number) => {
    tracking(
      Events.p2p_pools_intro_screen_swipe({
        source: serverData.trackingParameters.externalSource,
        page_variant: pageVariant,
      }),
    )
    setCurrentPage(index)
  }
  const renderIntroPage = (item: IntroPage, props: any) => {
    return (
      <div
        className={styles.introContentContainer}
        data-testid={item.id}
        {...props}
      >
        <ContainerGeneration
          item={item}
          goToPrivacyScreen={goToPrivacyScreen}
          isSmallerScreen={isSmallerScreen}
        />
      </div>
    )
  }

  const { CurrencyComponent, currencyDataTestId } = getCurrencyElements(
    currentUserCountryCode,
  )

  const introPages: Array<IntroPage> = [
    {
      id: 'firstPanelIntroContent',
      images: serverData?.ui?.introCarouselImagesByCountry?.firstImage || {},
      title: 'create.intro.title',
      firstIcon: (
        <CrowdfundIcon size={isSmallScreen ? 'sm' : 'md'} aria-hidden="true" />
      ),
      firstSubtitle: 'create.intro.trackItem',
      secondIcon: (
        <HideIcon size={isSmallScreen ? 'sm' : 'md'} aria-hidden="true" />
      ),
      secondSubtitle: isAnonymousAmountEnabled()
        ? 'intro.anonymousTransaction.privacyItem'
        : 'create.intro.privacyItem',
      showPrivacyLink: true,
    },
    {
      id: 'secondPanelIntroContent',
      images: serverData?.ui?.introCarouselImagesByCountry?.secondImage || {},
      title: 'create.intro.secondTitle',
      firstIcon: (
        <GoalsIcon size={isSmallScreen ? 'sm' : 'md'} aria-hidden="true" />
      ),
      firstSubtitle: 'create.intro.meetingGoal',
      secondIcon: (
        <CurrencyComponent
          size={isSmallScreen ? 'sm' : 'md'}
          data-testid={currencyDataTestId}
          aria-hidden="true"
        />
      ),
      secondSubtitle: 'create.intro.chipInGuest',
    },
    {
      id: 'thirdPanelIntroContent',
      images: serverData?.ui?.introCarouselImagesByCountry?.thirdImage || {},
      title: 'create.intro.thirdTitle',
      firstIcon: (
        <ShareMessengerIcon
          size={isSmallScreen ? 'sm' : 'md'}
          aria-hidden="true"
        />
      ),
      firstSubtitle: 'create.intro.sharePool',
      secondIcon: (
        <CopyToClipboardIcon
          size={isSmallScreen ? 'sm' : 'md'}
          aria-hidden="true"
        />
      ),
      secondSubtitle: 'create.intro.copyPaste',
    },
  ]

  return (
    <HorizontalScroll
      items={introPages}
      renderItem={renderIntroPage}
      numOfVisibleItems={1}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  )
}
